import React, { Component } from 'react';
import { Col, Row, Form, Input, Select, message, Spin } from 'antd';
import { Helmet } from "react-helmet";
import { FEEDBACK_URL } from "../../../utils/config";

import Support from '../Support';
import './Feedback.css'
import feedback from './imgs/icon_signup.svg';

const { TextArea } = Input;

class Feedback extends Component {

  state = {
    loading: false,
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          loading: true,
        });
        const FeedbackApi = `${FEEDBACK_URL}?name=${values.name}&email=${values.email}&type=${values.type}&comments=${values.comments}`;
        fetch(FeedbackApi, {
          method: 'POST',
        })
          .then((data) => {
            if (data.status === 200) {
              message.success('Successfully received your feedback, Thank you');
            } else {
              message.error('Oops! fail to submit. Please contact our customer service');
            }
            this.setState({
              loading: false,
            });
          })
          .catch(() => {
            message.error('Oops! fail to submit. Please contact our customer service');
            this.setState({
              loading: false,
            });
          });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="Feedback">
        <Helmet>
          <title>Feedback - Qbates</title>
          <meta name="description" content="Send Us Your Feedback" />
        </Helmet>
        <Support />
        <div className="Intro">
          <Row>
            <Col span="6">
              <img src={feedback} alt="Send us feedback"/>
            </Col>
            <Col span="18">
              <h2>Send Us Feeback</h2>
              <p>Qbates need your help! If you have any creative ideas or come across any issues when using QbatesApp, please feel free contact
                us via email: <b>  hello@qbatesapp.com  </b> or send us a quick comment below</p>
            </Col>
          </Row>
        </div>
        <div className="Form">
          <Spin spinning={this.state.loading}>
            <Form onSubmit={this.handleSubmit}>
              <Row gutter={32}>
                <Col span={8}>
                  <Form.Item>
                    <span>Your Name</span>
                    {getFieldDecorator('name', {
                      rules: [{ required: true, message: 'Please input your name' }],
                    })(
                      <Input type="text" placeholder="Name"/>
                    )}
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item>
                    <span>Email</span>
                    {getFieldDecorator('email', {
                      rules: [{
                        type: 'email', message: 'The input is not valid E-mail',
                      }, {
                        required: true, message: 'Please input your E-mail!',
                      }],
                    })(
                      <Input type="email" placeholder="Enter your email Address"/>
                    )}
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item>
                    <span>Feedback Type</span>
                    {getFieldDecorator('type', {
                      rules: [{ required: true, message: 'Please Select one type' }],
                    })(
                      <Select>
                        <Select.Option value="Function">Function</Select.Option>
                        <Select.Option value="iOS">iOS</Select.Option>
                        <Select.Option value="Android">Android</Select.Option>
                        <Select.Option value="Others">Others</Select.Option>
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item>
                    <span>Any feedback?</span>
                    {getFieldDecorator('comments', {
                      rules: [{ required: true, message: 'Enter your feedback' }],
                    })(
                      <TextArea placeholder="Leave your ideas or feeback here"/>
                    )}
                  </Form.Item>
                </Col>
                <Col span={24} className="Submit">
                  <Form.Item>
                    <button>SUBMIT</button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </div>
      </div>
    );
  }
}

const WrappedFeedback = Form.create()(Feedback);
export default WrappedFeedback;


// WEBPACK FOOTER //
// ./src/Containers/Support/components/Feedback.js